export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f48c4a7dd84e66255cf248c9db21ff6e6977785ae&name=fetchTypeahead!'